export const updateSurveyService = (fetchData) => async (survey) => {
  try {
    const response = await fetchData({
      url: "/api/v1/inspeccion-vehiculos/actualizar-encuesta",
      method: "put",
      body: survey,
      permission: "1",
    });

    return response;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Error al intentar actualizar la encuesta"
    );
  }
};
